import { IconChat } from '@leland-dev/leland-ui-library';
import React from 'react';

import type { OfferingPackageCoachMessagePromptCoachFragment } from './__generated-gql-types__/OfferingPackageCoachMessagePrompt.generated';

interface OfferingPackageCoachMessagePromptProps {
  coach: OfferingPackageCoachMessagePromptCoachFragment;
  onMessageCoach: () => void;
  blocked?: boolean;
  className?: string;
}

const OfferingPackageCoachMessagePrompt: React.FC<
  OfferingPackageCoachMessagePromptProps
> = ({ coach, onMessageCoach, blocked, className = '' }) => {
  return (
    <div
      className={`flex flex-col items-start justify-center rounded-xl bg-leland-gray-hover p-6 ${className}`}
    >
      <div className="flex items-start justify-between space-x-4">
        <div className="flex flex-col items-start justify-center">
          <h3 className="text-base font-medium text-leland-gray-dark">
            Want to chat with this coach first?
          </h3>
          <p className="mt-0.5 text-base font-normal leading-6 text-leland-gray-light">
            You can message {coach.user.firstName} to ask any questions or set
            up a time to chat before you get started.
          </p>
        </div>
        <IconChat className="size-5 shrink-0" />
      </div>
      <button
        type="button"
        className={`link link--primary mt-4 font-medium ${
          blocked ? 'button--disabled' : ''
        }`}
        disabled={blocked}
        onClick={onMessageCoach}
      >
        Send {coach.user.firstName} a message
      </button>
    </div>
  );
};

export default OfferingPackageCoachMessagePrompt;
